import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs } from '@togglecorp/fujs';
import Header from '../Header/index.js';
import Footer from '../Footer/index.js';
import Border from '../Border/index.js';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

const spacingToStyleMap = {
  none: styles.noSpacing,
  compact: styles.compactSpacing,
  comfortable: styles.comfortableSpacing,
  loose: styles.looseSpacing
};

function Container(props) {
  const {
    className,
    heading,
    children,
    headerActions,
    headerIcons,
    headingDescription,
    headerDescription,
    headerIconsContainerClassName,
    headerActionsContainerClassName,
    headerDescriptionClassName,
    headerClassName,
    headingClassName,
    contentClassName,
    footerContent,
    footerIcons,
    footerActions,
    footerClassName,
    footerIconsContainerClassName,
    footerActionsContainerClassName,
    headingSectionClassName,
    footerContentClassName,
    footerQuickActionsContainerClassName,
    containerElementProps,
    headingSize,
    footerQuickActions,
    headerElementProps,
    elementRef: elementRefFromProps,
    headingContainerClassName,
    inlineHeadingDescription,
    autoFocus,
    spacing = 'comfortable',
    borderBelowHeader,
    borderBelowHeaderWidth,
    borderBelowHeaderClassName,
    ellipsizeHeading,
    withoutExternalPadding,
    visibleOverflow,
    headingDescriptionClassName,
    errored
  } = props;
  const internalRef = React.useRef(null);
  const elementRef = elementRefFromProps ?? internalRef;
  React.useEffect(() => {
    if (autoFocus && elementRef.current) {
      elementRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }, [autoFocus, elementRef]);
  return /*#__PURE__*/React.createElement("div", _extends({}, containerElementProps, {
    className: _cs(styles.container, autoFocus && styles.autoFocused, spacingToStyleMap[spacing], withoutExternalPadding && styles.withoutExternalPadding, visibleOverflow && styles.visibleOverflow, errored && styles.errored, className),
    ref: elementRef
  }), (heading || headerActions || headerIcons) && /*#__PURE__*/React.createElement(Header, {
    icons: headerIcons,
    actions: headerActions,
    className: _cs(styles.header, headerClassName),
    heading: heading,
    headingSize: headingSize,
    description: headingDescription,
    iconsContainerClassName: headerIconsContainerClassName,
    actionsContainerClassName: headerActionsContainerClassName,
    descriptionClassName: headingDescriptionClassName,
    childrenContainerClassName: headerDescriptionClassName,
    headingSectionClassName: headingSectionClassName,
    headingClassName: headingClassName,
    elementProps: headerElementProps,
    headingContainerClassName: headingContainerClassName,
    inlineHeadingDescription: inlineHeadingDescription,
    spacing: spacing,
    ellipsizeHeading: ellipsizeHeading
  }, headerDescription), borderBelowHeader && /*#__PURE__*/React.createElement(Border, {
    extendToSpacing: true,
    spacing: spacing,
    className: borderBelowHeaderClassName,
    width: borderBelowHeaderWidth,
    inline: true
  }), /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.content, contentClassName)
  }, children), (footerIcons || footerContent || footerActions || footerQuickActions) && /*#__PURE__*/React.createElement(Footer, {
    actions: footerActions,
    className: _cs(styles.footer, footerClassName),
    iconsContainerClassName: footerIconsContainerClassName,
    childrenContainerClassName: footerContentClassName,
    actionsContainerClassName: footerActionsContainerClassName,
    quickActionsContainerClassName: footerQuickActionsContainerClassName,
    quickActions: footerQuickActions,
    icons: footerIcons
  }, footerContent));
}

var Container$1 = genericMemo(Container);

export { Container$1 as default };
//# sourceMappingURL=index.js.map
